import { Box } from "@mui/material"
import LogoTextImage from '../../assets/Icons/enphase_logo_with_text.png'
import { useStyles } from './style'

const Footer = () => {
  const classes = useStyles()

  const handleDNSSClick = () => {
    const hostname = window.location.hostname
    if (
      hostname.includes('grid-intake.enphaseenergy.com') ||
      hostname.includes('grid-intake-stg.qa-enphaseenergy.com') ||
      hostname.includes('gs-intake-portal-ui-intg.qa-enphaseenergy.com')
    ) {
      if (window.OneTrust) {
        window.OneTrust.ToggleInfoDisplay()
      } else if (window.Optanon) {
        window.Optanon.ToggleInfoDisplay()
      }
    }
  }

  return (
    <Box className={classes.container} width="100%" display="flex" alignItems="center" flexWrap="wrap">
      <Box>
        <img src={LogoTextImage} className={classes.logoImage} alt='logo' />
      </Box>
      <Box>
        <Box className={classes.text} sx={{ mx: '40px', my: 0.5 }}>
          {`© 2008-${new Date().getFullYear()} Enphase Energy Inc. All rights reserved.`}
          <Box component="span" ml={1}>
            <a
              className={classes.anchorlink}
              href="https://enphase.com/privacy "
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy
            </a>
            <span className={classes.anchorlink}> | </span>
            <a
              className={classes.anchorlink}
              href="https://enphase.com/terms "
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms
            </a>
            <span className={classes.anchorlink}> | </span>
            <a
              className={classes.anchorlink}
              href="javascript:void(0);"
              onClick={handleDNSSClick}
              role="button"
              rel="noopener noreferrer"
            >
              {'Settings / Do not sell or share my personal information'}
            </a>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default Footer